/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_5_QInputs */

const en_mk_pricing_faq_5_q = /** @type {(inputs: Mk_Pricing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I try it without entering a card?`)
};

const id_mk_pricing_faq_5_q = /** @type {(inputs: Mk_Pricing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisakah saya mencoba tanpa memasukkan kartu?`)
};

/**
* | output |
* | --- |
* | "Can I try it without entering a card?" |
*
* @param {Mk_Pricing_Faq_5_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_5_q = /** @type {((inputs?: Mk_Pricing_Faq_5_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_5_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_5_q(inputs)
	return en_mk_pricing_faq_5_q(inputs)
});